import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Support } from './support.model';
import supportService from './support.service';

// namespace
export const SUPPORT_STORE_NAMESPACE = 'supportStore';

// state
interface SupportState {
  supports: Support[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: SupportState = {
  supports: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<SupportState> = {
  [mutationConstant.FETCH]: (state: SupportState, supports: Support[]) => {
    state.supports = supports;
  },
  [mutationConstant.PENDING]: (state: SupportState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: SupportState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: SupportState) => {
    state.status = 'failed';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<SupportState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<SupportState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      supportService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<SupportState, RootState> = {
  [getterConstant.ALL]: (state: SupportState) => state.supports,
  [getterConstant.BY_ID]: (state: SupportState) => (id: number) => state.supports.find(m => m.id === id),
  [getterConstant.STATUS]: (state: SupportState) => state.status,
};

// module
const module: Module<SupportState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const SupportGetter = {
  ALL: `${SUPPORT_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${SUPPORT_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${SUPPORT_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const SupportAction = {
  FETCH: `${SUPPORT_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
